import { render, staticRenderFns } from "./DetailRowNew.vue?vue&type=template&id=7d9b8be1&scoped=true&"
import script from "./DetailRowNew.vue?vue&type=script&lang=js&"
export * from "./DetailRowNew.vue?vue&type=script&lang=js&"
import style0 from "./DetailRowNew.vue?vue&type=style&index=0&id=7d9b8be1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9b8be1",
  null
  
)

export default component.exports